import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store/index.js'
import { getToken, setToken, removeToken } from '@/utils/auth'
const service = axios.create({
 // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
baseURL:"https://test.metabiz.com.cn/api/public/index.php/",
  timeout: 300000000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers['token'] = getToken()
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
18833403010
service.interceptors.response.use(
  response => {
    const res = response.data
	console.log("res",res);
    if (res.code !== 0 && res && res.code!==98) {
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })

      if (res.code ==  3002) {
        // to re-login
		loginEvent.$emit('loginDialogEvent');
        store.dispatch('user/resetToken').then(() => {
          //this.$router.push({ path: this.$route.path || '/', query: this.$route.query })
		  //loginEvent.$emit('loginDialogEvent');
        })
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js